// extracted by mini-css-extract-plugin
export default {"price":"K8-z","onSale":"L8-z","msrpLabelPrice":"M8-z","msrpLabel":"N8-z","originalPrice":"O8-z","percentOff":"P8-z"};